function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import utils from './utils';
import {
    Picker,
    MultiPicker,
    Slider,
    Slider_vertical,
    Switch
} from './components/components';
import Template from './template';
import VideoColor from './videoColor';
import Feedback from './feedback';
import Clock from './clock';
import { VList } from './components/VList';
var Set = function () {
    function Set(player) {
        var _this = this;
        _classCallCheck(this, Set);
        _defineProperty(this, 'handleHide', function () {
            _this.setMask.classList.add('hide');
            if (_this.setMode === 'danmakuList') {
                _this.player.template.danmakuList.innerHTML = null;
            }
            _this.player.template[''.concat(_this.setMode, 'Mask')].removeEventListener('transitionend', _this.handleHide);
            _this.hideCallback && _this.hideCallback();
            _this.setMode = null;
        });
        this.player = player;
        this.components = player.components;
        this.setMask = this.player.template.setMask;
        this.videoColor = new VideoColor(player);
        this.videoScale = false;
        this.videoIsMirror = false;
        this.setMode = null;
        this.preVideoStatus = null;
        this.danmakuParams = {
            type: 'right',
            text: '',
            size: 18
        };
        this.stopPropagation(this.setMask);
        this.initSpeedSet();
        this.initResolutionSet();
        if (this.player.options.video.length > 1) {
            this.initSquirtleSet();
        }
        this.initDanmakuEdit();
        this.initDanmakuSet();
        this.initPlaySet();
        this.clock = new Clock(player);
        this.feedback = new Feedback(player);
        this.touchStartY = 0;
        this.touchEndY = 0;
        this.locked = false;
    }
    _createClass(Set, [
        {
            key: 'stopPropagation',
            value: function stopPropagation(el) {
                var _this2 = this;
                var stopTouchendPropagation = function stopTouchendPropagation(e) {
                    e.stopPropagation();
                    el.removeEventListener('touchend', stopTouchendPropagation, true);
                    _this2.locked = false;
                };
                el.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    if (e.target === _this2.setMask) {
                        _this2.hide(_this2.setMode);
                        if (_this2.setMode === 'danmakuList' || _this2.setMode === 'danmakuReport') {
                            _this2.player.play();
                        }
                    }
                });
                el.addEventListener(utils.nameMap.dragMove, function (e) {
                    e.stopPropagation();
                });
                el.addEventListener(utils.nameMap.dragStart, function (e) {
                    e.stopPropagation();
                });
            }
        },
        {
            key: 'initSpeedSet',
            value: function initSpeedSet() {
                var _this3 = this;
                this.stopPropagation(this.player.template.speedMask);
                this.player.template.speed.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this3.show('speed');
                });
                var _loop = function _loop(i) {
                    _this3.player.template.speedItem[i].addEventListener(utils.nameMap.dragEnd, function (e) {
                        var currentSpeed = _this3.player.template.speedItem[i].dataset.speed;
                        _this3.player.speed(currentSpeed);
                        _this3.player.template.speedItem[i].classList.add('focus');
                        _this3.player.template.speed.innerHTML = currentSpeed !== '1.0' ? currentSpeed + 'x' : '倍速';
                        _this3.player.template.speedItem.forEach(function (element, index) {
                            if (index !== i) {
                                element.classList.remove('focus');
                            }
                        });
                        _this3.hide(_this3.setMode);
                    });
                };
                for (var i = 0; i < this.player.template.speedItem.length; i++) {
                    _loop(i);
                }
            }
        },
        {
            key: 'initResolutionSet',
            value: function initResolutionSet() {
                var _this4 = this;
                this.stopPropagation(this.player.template.resolutionMask);
                this.player.template.resolution.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this4.show('resolution');
                    _this4.player.template.resolutionMask.classList.add('show');
                });
                var _loop2 = function _loop2(i) {
                    _this4.player.template.resolutionItem[i].addEventListener(utils.nameMap.dragEnd, function (e) {
                        if (_this4.player.switchingResolution)
                            return;
                        var currentResolution = JSON.parse(_this4.player.template.resolutionItem[i].dataset.resolution);
                        console.log(currentResolution);
                        _this4.player.switchResolution(currentResolution);
                        _this4.player.events.on('resolution_end', function () {
                            _this4.player.template.resolutionItem[i].classList.add('focus');
                            _this4.player.template.resolutionItem.forEach(function (element, index) {
                                if (index !== i) {
                                    element.classList.remove('focus');
                                }
                            });
                        });
                        _this4.hide(_this4.setMode);
                    });
                };
                for (var i = 0; i < this.player.template.resolutionItem.length; i++) {
                    _loop2(i);
                }
            }
        },
        {
            key: 'initSquirtleSet',
            value: function initSquirtleSet() {
                var _this5 = this;
                this.player.template.episodeMask.addEventListener('touchmove', function (ev) {
                    _this5.locked || (_this5.locked = true, _this5.player.template.episodeMask.addEventListener('touchend', stopTouchendPropagation, true));
                }, true);
                var stopTouchendPropagation = function stopTouchendPropagation(ev) {
                    ev.stopPropagation();
                    _this5.player.template.episodeMask.removeEventListener('touchend', stopTouchendPropagation, true);
                    _this5.locked = false;
                };
                this.player.template.episode.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this5.show('episode');
                });
                var _loop3 = function _loop3(i) {
                    _this5.player.template.episodeItem[i].addEventListener(utils.nameMap.dragEnd, function (e) {
                        e.stopPropagation();
                        _this5.player.switchVideo(i);
                        _this5.hide(_this5.setMode);
                    });
                };
                for (var i = 0; i < this.player.template.episodeItem.length; i++) {
                    _loop3(i);
                }
                this.player.template.skip.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    var nextVideo = _this5.player.currentVideo + 1;
                    _this5.player.switchVideo(nextVideo);
                });
            }
        },
        {
            key: 'initDanmakuEdit',
            value: function initDanmakuEdit() {
                var _this6 = this;
                this.player.template.input.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    if (_this6.player.template.input.classList.contains('noLogin'))
                        return;
                    _this6.player.pause();
                    _this6.preVideoStatus = _this6.player.template.container.classList.contains('mfunsPlayer-playing') ? 'play' : 'pause';
                    _this6.show('danmakuEdit');
                    _this6.player.template.danmakuEditMask.addEventListener('transitionend', function () {
                        _this6.player.template.danmakuEditMask.classList.contains('show') && _this6.player.template.danmakuText.focus();
                    });
                });
                this.player.template.danmakuEditMask.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                });
                this.player.template.danmakuCancelEdit.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    if (_this6.preVideoStatus === 'play')
                        _this6.player.play();
                    _this6.hide(_this6.setMode);
                });
                this.player.template.loginBtn && this.player.template.loginBtn.addEventListener(utils.nameMap.dragStart, function (e) {
                    e.stopPropagation();
                    _this6.player.fullScreen.cancel();
                    _this6.player.events && _this6.player.events.trigger('toLogin');
                });
                var _loop4 = function _loop4(i) {
                    _this6.player.template.danmakuSizeItem[i].addEventListener(utils.nameMap.dragEnd, function (e) {
                        e.stopPropagation();
                        _this6.danmakuParams.size = _this6.player.template.danmakuSizeItem[i].dataset.size * 1;
                        _this6.player.template.danmakuSizeItem[i].classList.add('focus');
                        _this6.player.template.danmakuSizeItem.forEach(function (element, index) {
                            if (index !== i) {
                                element.classList.remove('focus');
                            }
                        });
                    });
                };
                for (var i = 0; i < this.player.template.danmakuSizeItem.length; i++) {
                    _loop4(i);
                }
                var _loop5 = function _loop5(_i) {
                    _this6.player.template.danmakuTypeItem[_i].addEventListener(utils.nameMap.dragEnd, function (e) {
                        e.stopPropagation();
                        _this6.danmakuParams.type = _this6.player.template.danmakuTypeItem[_i].dataset.type;
                        _this6.player.template.danmakuTypeItem[_i].classList.add('focus');
                        _this6.player.template.danmakuTypeItem.forEach(function (element, index) {
                            if (index !== _i) {
                                element.classList.remove('focus');
                            }
                        });
                    });
                };
                for (var _i2 = 0; _i2 < this.player.template.danmakuTypeItem.length; _i2++) {
                    _loop5(_i2);
                }
                var _loop6 = function _loop6(_i3) {
                    _this6.player.template.danmakuColorItem[_i3].addEventListener(utils.nameMap.dragEnd, function (e) {
                        e.stopPropagation();
                        _this6.danmakuParams.color = _this6.player.template.danmakuColorItem[_i3].dataset.color;
                        _this6.player.template.danmakuColorItem[_i3].classList.add('focus');
                        _this6.player.template.danmakuColorItem.forEach(function (element, index) {
                            if (index !== _i3) {
                                element.classList.remove('focus');
                            }
                        });
                    });
                };
                for (var _i4 = 0; _i4 < this.player.template.danmakuColorItem.length; _i4++) {
                    _loop6(_i4);
                }
                this.player.template.danmakuEmit.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    if (_this6.player.template.danmakuText.value.trim()) {
                        _this6.danmakuParams.text = _this6.player.template.danmakuText.value;
                        _this6.player.sendDanmaku(_this6.danmakuParams);
                        _this6.player.template.danmakuText.value = null;
                        if (_this6.preVideoStatus === 'play')
                            _this6.player.play();
                        _this6.hide(_this6.setMode);
                        console.log(_this6.danmakuParams);
                    }
                });
            }
        },
        {
            key: 'initDanmakuSet',
            value: function initDanmakuSet() {
                var _this7 = this;
                this.player.template.danmakuSet.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this7.show('danmakuSet');
                    _this7.shieldType = [];
                });
                var shields = this.player.options.danmaku.shields;
                var opacity = this.player.options.danmaku.opacity;
                var showArea = this.player.options.danmaku.limitArea;
                var danmakuSize = this.player.options.danmaku.fontScale;
                var danmakuSpeed = this.player.options.danmaku.speed;
                this.danmakuFilter = new MultiPicker(this.player.template.danmaku_filter_picker, shields, {
                    created: function created(thisArg) {
                    },
                    pick: function pick(value, nonotice) {
                        console.log('屏蔽弹幕类型\uFF1A'.concat(value));
                        _this7.player.danmaku && _this7.player.danmaku.shield(value, true);
                    },
                    unpick: function unpick(value) {
                        console.log('取消屏蔽弹幕类型\uFF1A'.concat(value));
                        _this7.player.danmaku && _this7.player.danmaku.shield(value, false);
                    },
                    update: function update(value) {
                    }
                });
                new Slider(this.player.template.danmaku_opacity_slider, 10, 100, 1, opacity * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                        _this7.player.danmaku.opacity(value / 100);
                    },
                    change: function change(value) {
                        _this7.player.template.danmaku_opacity_value.innerText = ''.concat(value, '%');
                    },
                    end: function end(value) {
                        _this7.player.events && _this7.player.events.trigger('setDanmaku', {
                            key: 'opacity',
                            value: value / 100
                        });
                    }
                }, this.setMask);
                new Slider(this.player.template.danmaku_showarea_slider, 20, 100, 20, showArea * 20, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        _this7.player.template.danmaku_showarea_value.innerText = [
                            '1/4屏',
                            '半屏',
                            '3/4屏',
                            '不重叠',
                            '不限'
                        ][value / 20 - 1];
                        _this7.player.danmaku && _this7.player.danmaku.limitArea(value / 20);
                    },
                    end: function end(value) {
                        _this7.player.events && _this7.player.events.trigger('setDanmaku', {
                            key: 'limitArea',
                            value: value / 20
                        });
                    }
                }, this.setMask);
                new Slider(this.player.template.danmaku_size_slider, 50, 150, 1, danmakuSize * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        _this7.player.template.danmaku_size_value.innerText = value + '%';
                        _this7.player.danmaku && _this7.player.danmaku.size(value / 100);
                    },
                    end: function end(value) {
                        _this7.player.events && _this7.player.events.trigger('setDanmaku', {
                            key: 'fontScale',
                            value: Number((value / 100).toFixed(2))
                        });
                    }
                }, this.setMask);
                new Slider(this.player.template.danmaku_speed_slider, 50, 150, 25, danmakuSpeed * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        _this7.player.template.danmaku_speed_value.innerText = utils.number2danmakuSpeed(value / 100);
                        _this7.player.danmaku && _this7.player.danmaku.speed(value / 100);
                    },
                    end: function end(value) {
                        _this7.player.events && _this7.player.events.trigger('setDanmaku', {
                            key: 'speed',
                            value: value / 100
                        });
                    }
                }, this.setMask);
            }
        },
        {
            key: 'initPlaySet',
            value: function initPlaySet() {
                var _this8 = this;
                this.player.template.playerSet.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var videoMask = _this8.player.template.videoMask;
                    if (videoMask.classList.contains('fullscreen')) {
                        _this8.show('playerSet');
                    } else {
                        _this8.player.events.trigger('report');
                    }
                });
                this.player.template.videoMirror.addEventListener(utils.nameMap.dragEnd, function (e) {
                    _this8.videoIsMirror = !_this8.videoIsMirror;
                    _this8.player.template.videoMirror.classList[_this8.videoIsMirror ? 'add' : 'remove']('active');
                    _this8.player.video.style.transform = _this8.videoIsMirror ? 'rotateY(180deg)' : 'none';
                });
                this.player.template.videoFilter.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this8.hide(_this8.setMode, false);
                    _this8.show('videoFilter');
                    var _this8$videoColor$fil = _this8.videoColor.filter, saturate = _this8$videoColor$fil.saturate, contrast = _this8$videoColor$fil.contrast, brightness = _this8$videoColor$fil.brightness;
                    console.log(_this8.player.template.videoFilterItem);
                    var _loop7 = function _loop7(i) {
                        _this8.player.template.videoFilterItem[i].addEventListener(utils.nameMap.dragEnd, function (e) {
                            var value = _this8.player.template.videoFilterItem[i].dataset.value;
                            _this8.player.template.videoFilterItem.forEach(function (element, index) {
                                element.classList.remove('focus');
                            });
                            _this8.player.template.videoFilterItem[i].classList.add('focus');
                            _this8.player.video.style.filter = value || 'brightness('.concat(brightness, ') contrast(').concat(contrast, ') saturate(').concat(saturate, ')');
                        });
                    };
                    for (var i = 0; i < _this8.player.template.videoFilterItem.length; i++) {
                        _loop7(i);
                    }
                });
                this.player.template.videoColor.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this8.hide(_this8.setMode, false);
                    _this8.show('videoColor');
                });
                this.player.template.videoClock.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this8.hide(_this8.setMode, false);
                    _this8.show('videoClock');
                });
                this.player.template.feedback.addEventListener(utils.nameMap.dragEnd, function (e) {
                    e.stopPropagation();
                    _this8.hide(_this8.setMode, false);
                    _this8.feedback.clearFeedBack();
                    _this8.show('feedback');
                });
                this.player.template.aspectRatio.addEventListener('click', function (e) {
                    var element = e.target;
                    var allOptions = _toConsumableArray(_this8.player.template.aspectRatio.querySelectorAll('.mfunsPlayer-player-set-option'));
                    switch (element.innerText) {
                    case '自动':
                        allOptions.forEach(function (el) {
                            return el.classList.remove('focus');
                        });
                        element.classList.add('focus');
                        _this8.videoScale = false;
                        break;
                    case '16:9':
                    case '4:3':
                        allOptions.forEach(function (el) {
                            return el.classList.remove('focus');
                        });
                        element.classList.add('focus');
                        ''.concat(element.innerText).replace(/^([0-9]+):([0-9]+)$/, function (match, w, h) {
                            if (match) {
                                _this8.videoScale = [
                                    Number(w),
                                    Number(h)
                                ];
                            }
                        });
                        break;
                    case '拉伸':
                        console.log('拉伸');
                        allOptions.forEach(function (el) {
                            return el.classList.remove('focus');
                        });
                        element.classList.add('focus');
                        _this8.videoScale = [
                            1,
                            1
                        ];
                        break;
                    case '填充':
                        console.log('填充');
                        allOptions.forEach(function (el) {
                            return el.classList.remove('focus');
                        });
                        element.classList.add('focus');
                        _this8.videoScale = [
                            1,
                            0
                        ];
                        break;
                    }
                    _this8.player.resize();
                });
                this.player.template.playMode.addEventListener('click', function (e) {
                    var element = e.target;
                    var allOptions = _toConsumableArray(_this8.player.template.playMode.querySelectorAll('.mfunsPlayer-player-set-option'));
                    if (allOptions.includes(element)) {
                        allOptions.forEach(function (el) {
                            return el.classList.remove('focus');
                        });
                        element.classList.add('focus');
                    }
                    switch (element.innerText) {
                    case '播完暂停':
                        _this8.player.video.loop = false;
                        _this8.player.listLoop = false;
                        _this8.player.autoSwitch = false;
                        break;
                    case '洗脑循环':
                        _this8.player.video.loop = true;
                        _this8.player.listLoop = false;
                        _this8.player.autoSwitch = false;
                        break;
                    case '列表循环':
                        _this8.player.video.loop = false;
                        _this8.player.listLoop = true;
                        break;
                    case '自动切集':
                        _this8.player.video.loop = false;
                        _this8.player.listLoop = false;
                        _this8.player.autoSwitch = true;
                        break;
                    }
                    var _this8$player = _this8.player, autoSwitch = _this8$player.autoSwitch, listLoop = _this8$player.listLoop, loop = _this8$player.video.loop;
                    _this8.player.events.trigger('setPlayer', {
                        key: 'playMode',
                        value: {
                            autoSwitch: autoSwitch,
                            listLoop: listLoop,
                            loop: loop
                        }
                    });
                    _this8.player.resize();
                });
                this.player.template.currentDanmakuListBtn.addEventListener('click', function () {
                    _this8.player.pause();
                    _this8.hide('danmakuSet', false);
                    _this8.show('danmakuList');
                    var currentDan = _toConsumableArray(document.querySelectorAll('.mfunsPlayer-danmaku-item')).slice(1).map(function (dan) {
                        return _this8.player.danmaku.getDanmakuData(dan.dataset.id);
                    });
                    var danList = currentDan.map(function (dan) {
                        return Template.NewDanmakuListItem(dan);
                    });
                    _this8.player.template.danmakuList.innerHTML = null;
                    danList.forEach(function (el, index) {
                        _this8.player.template.danmakuList.appendChild(el);
                        var copyBtn = el.querySelector('.danmaku-operate-item.copy');
                        var reportBtn = el.querySelector('.danmaku-operate-item.report');
                        copyBtn.addEventListener('click', function () {
                            if (navigator.clipboard) {
                                navigator.clipboard.writeText(el.querySelector('.danmaku-text').innerText).then(function () {
                                    _this8.player.notice('复制成功');
                                })['catch'](function (err) {
                                    console.log(err);
                                });
                            } else {
                                _this8.player.events.trigger('danmaku_copy', el.querySelector('.danmaku-text').innerText);
                            }
                        });
                        reportBtn.addEventListener('click', function () {
                            var maskDanContent = _this8.player.template.danmakuReportMask.querySelector('.danmaku-content');
                            maskDanContent.innerText = el.querySelector('.danmaku-text').innerText;
                            maskDanContent.dataset.danData = JSON.stringify(currentDan[index]);
                            _this8.hide('danmakuList', false);
                            _this8.feedback.clearDanmakuReport();
                            _this8.show('danmakuReport');
                        });
                    });
                });
            }
        },
        {
            key: 'show',
            value: function show(type) {
                this.player.controller.hide();
                this.setMask.classList.remove('hide');
                this.player.template[''.concat(type, 'Mask')].classList.add('show');
                this.setMode = type;
            }
        },
        {
            key: 'hide',
            value: function hide(type) {
                var _this$player$template, _this$player$template2;
                var clearAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
                };
                type === 'danmakuEdit' && this.player.template.danmakuText.blur();
                (_this$player$template = this.player.template[''.concat(this.setMode || type, 'Mask')]) === null || _this$player$template === void 0 ? void 0 : _this$player$template.classList.remove('show');
                clearAll && ((_this$player$template2 = this.player.template[''.concat(this.setMode || type, 'Mask')]) === null || _this$player$template2 === void 0 ? void 0 : _this$player$template2.addEventListener('transitionend', this.handleHide));
                this.hideCallback = cb;
            }
        }
    ]);
    return Set;
}();
export {
    Set as default
};